module.exports = __webpack_public_path__ + "img/zzhl.8c71792d.png";